import React, { useState, useEffect } from "react";
import styled from "styled-components";
import TitleHeader from "components/presenters/header/TitleHeader";
import { Link } from "react-router-dom";
import userImg from "../../../images/basicimg03.png";
import fnbtn from "../../../images/fnbtn.png";
import friend_check from "../../../images/friend_check.png";
import serverController from "../../../server/serverController";
import appInfoContainer from "../../../auth/appInfoContainer";

import approvedBell from "images/character/approved_bell-106×106.png";
import deniedBell from "images/character/denied_bell-106×106.png";

const Addlist = [
  { title: "오늘 해야 할 투두리스트가 있어요!", time: "10S", btntxt: "친구" },
  { title: "오늘 해야 할 투두리스트가 있어요!", time: "10S", btntxt: "친구" },
];

export default function MypageSettingAlarm() {
  // 알림리스트 데이터 받아오기
  const [submittingReq, setSubmittingReq] = useState(false);
  const [alarmlist, setAlarmlist] = useState([]);
  const [lastPosNo, setLastPosNo] = useState(null);
  const [dataLoading, setDataLoading] = useState(false);
  const [loadNext, setLoadNext] = useState(true);
  const [reachedLastItem, setReachedLastItem] = useState(false);
  const infoCallBack = (jsonData) => {
    if (jsonData === null || jsonData.success !== 1) {
      alert("예기치 못한 문제가 발생하였습니다.");
      return;
    } else {
      let newNotificationList = jsonData.data.notifications;
      let lastPosIndex = newNotificationList.length - 1;
      if (newNotificationList.length > 0) {
        setLastPosNo(newNotificationList[lastPosIndex]["no"]);
        setAlarmlist(alarmlist.concat(newNotificationList));
      } else {
        setReachedLastItem(true);
      }
    }
    setDataLoading(false);
  };
  const unreadCheckCallback = (jsonData) => {
    if (jsonData.success !== 1) {
      alert("예기치 못한 문제가 발생하였습니다.");
      return;
    }
  };
  useEffect(() => {
    serverController.generalPutFetchController(
      `notifications/unread`,
      JSON.stringify({}),
      unreadCheckCallback
    );
  }, []);

  useEffect(() => {
    if (!dataLoading && loadNext) {
      setLoadNext(false);
      setDataLoading(true);
      let queryString = "";
      if (lastPosNo) {
        queryString = `?last_pos_no=${lastPosNo}`;
      }
      serverController.getServerData(
        `notifications${queryString}`,
        infoCallBack
      );
    }
  }, [loadNext]);

  const handleScroll = (e) => {
    const bottom =
      e.target.scrollHeight - e.target.scrollTop - 100 <= e.target.clientHeight;
    if (!reachedLastItem && bottom) {
      setLoadNext(true);
    }
  };

  // 친구신청 수락하기
  const [currentPostIndex, setCurrentPostIndex] = useState(0);
  const joinCallBack = (res) => {
    setSubmittingReq(false);
    if (res.success === 1) {
      window.location.reload();
    } else {
      alert("실패");
    }
  };

  /*--click block--*/
  const joinSubmit = (indexOptional) => {
    if (submittingReq) return;
    setSubmittingReq(true);
    var postIndex = indexOptional ? indexOptional : currentPostIndex;
    let data = {};
    serverController.generalPostFetchController(
      `friends/requests/${postIndex}`,
      JSON.stringify(data),
      joinCallBack
    );
  };

  const getTaskLikeTxt = (value) => {
    let detailJson = value["detail_json"];
    let totalLike = value["detail_json"]["data"]["total_like"];
    let userList = value["detail_json"]["data"]["user_list"];
    if (userList.length >= 3)
      return `${userList[0].nickname}, ${userList[1].nickname}님이 외 ${totalLike}명이 게시물에 좋아요를 눌렀어요`;
    else if (userList.length === 2)
      return `${userList[0].nickname}, ${userList[1].nickname}님이 게시물에 좋아요를 눌렀어요`;
    else if (userList.length === 1)
      return ` ${userList[0].nickname}님이 게시물에 좋아요를 눌렀어요`;
    else return "회원님의 게시물에 좋아요를 눌렀어요";
  };

  const getPostLikeTxt = (value) => {
    let detailJson = value["detail_json"];
    let totalLike = value["detail_json"]["data"]["total_like"];
    let userList = value["detail_json"]["data"]["user_list"];
    if (userList.length >= 3)
      return `${userList[0].nickname}, ${userList[1].nickname}님이 외 ${totalLike}명이 커뮤니티 게시물에 좋아요를 눌렀어요`;
    else if (userList.length === 2)
      return `${userList[0].nickname}, ${userList[1].nickname}님이 커뮤니티 게시물에 좋아요를 눌렀어요`;
    else if (userList.length === 1)
      return ` ${userList[0].nickname}님이 커뮤니티 게시물에 좋아요를 눌렀어요`;
    else return "회원님의 커뮤니티 게시물에 좋아요를 눌렀어요";
  };

  return (
    <MypageSetInner onScroll={handleScroll}>
      <TitleHeader
        title={"알람"}
        borderbottom={"solid calc(100vw*(1/375)) #d5d5d5"}
      />
      <Setlistinner>
        {alarmlist.map((value) => {
          let detailData = value.detail_json.data;
          // let userList = value.detail_json?.data.user_list
          let itemType = value.detail_json.type;

          let iconUserNo = null;
          let userIconImg = userImg;
          let notificationLinkURL = null;
          let titleTxt = "";

          let emptyNotification = false;

          if (itemType === "task_comment") {
            iconUserNo = detailData["user_no"];
            userIconImg = detailData["profile_img"]
              ? appInfoContainer.imagePath +
                "/user_profile_img/" +
                detailData["profile_img"]
              : userImg;
            notificationLinkURL = `/task/${detailData["task_no"]}`;

            titleTxt = detailData.nickname + "님이 게시물에 댓글을 달았어요";
          } else if (
            itemType === "task_like" &&
            Array.isArray(detailData["user_list"]) &&
            detailData["user_list"].length > 0
          ) {
            iconUserNo = detailData["user_list"][0]["user_no"];
            userIconImg =
              appInfoContainer.imagePath +
              "/user_profile_img/" +
              detailData["user_list"][0]["profile_img"];
            notificationLinkURL = `/task/${detailData["task_no"]}`;

            titleTxt = getTaskLikeTxt(value);
          } else if (itemType === "campaign_post_comment") {
            iconUserNo = detailData["user_no"];
            userIconImg =
              appInfoContainer.imagePath +
              "/user_profile_img/" +
              detailData["profile_img"];
            notificationLinkURL = `/campaign/${detailData["campaign_no"]}/post/${detailData["post_no"]}`;
            titleTxt = `회원님의 오픈프로젝트 커뮤니티 게시물에 댓글이 달렸어요`;
          } else if (itemType === "group_post_comment") {
            iconUserNo = detailData["user_no"];
            userIconImg =
              appInfoContainer.imagePath +
              "/user_profile_img/" +
              detailData["profile_img"];
            notificationLinkURL = `/group/${detailData["group_no"]}/post/${detailData["post_no"]}`;
            titleTxt = `회원님의 커뮤니티 게시물에 댓글이 달렸어요`;
          } else if (itemType === "campaign_post") {
            //let nickname = detailData['data']['nickname'];
            iconUserNo = detailData["user_no"];
            userIconImg =
              appInfoContainer.imagePath +
              "/user_profile_img/" +
              detailData["profile_img"];
            notificationLinkURL = `/campaign/${detailData["campaign_no"]}/community`;
            titleTxt = `'${detailData["campaign_title"]}'의 새로운 커뮤니티 게시물을 확인하세요!`;
          } else if (itemType === "group_post") {
            //let nickname = detailData['data']['nickname'];
            iconUserNo = detailData["user_no"];
            userIconImg =
              appInfoContainer.imagePath +
              "/user_profile_img/" +
              detailData["profile_img"];
            notificationLinkURL = `/group/${detailData["group_no"]}/community`;
            titleTxt = `'${detailData["group_title"]}'의 새로운 커뮤니티 게시물을 확인하세요!`;
          } else if (
            itemType === "campaign_post_like" &&
            Array.isArray(detailData["user_list"]) &&
            detailData["user_list"].length > 0
          ) {
            iconUserNo = detailData["user_list"][0]["user_no"];
            userIconImg =
              appInfoContainer.imagePath +
              "/user_profile_img/" +
              detailData["user_list"][0]["profile_img"];
            notificationLinkURL = `/campaign/${detailData["post"]["campaign_no"]}/post/${detailData["post"]["no"]}`;

            titleTxt = getPostLikeTxt(value);
          } else if (
            itemType === "group_post_like" &&
            Array.isArray(detailData["user_list"]) &&
            detailData["user_list"].length > 0
          ) {
            iconUserNo = detailData["user_list"][0]["user_no"];
            userIconImg =
              appInfoContainer.imagePath +
              "/user_profile_img/" +
              detailData["user_list"][0]["profile_img"];
            notificationLinkURL = `/group/${detailData["post"]["group_no"]}/post/${detailData["post"]["no"]}`;

            titleTxt = getPostLikeTxt(value);
          } else if (itemType === "friend_request") {
            userIconImg =
              appInfoContainer.imagePath +
              "/user_profile_img/" +
              detailData["from_profile_img"];
          } else if (itemType === "campaign_join_denied") {
            userIconImg = deniedBell;
            notificationLinkURL = `/campaign/${detailData["campaign_no"]}/info`;
            titleTxt = `'${detailData["campaign_title"]}'참여가 승인거절 되었어요`;
          } else if (itemType === "campaign_join_approved") {
            userIconImg = approvedBell;
            notificationLinkURL = `/campaign/${detailData["campaign_no"]}/info`;
            titleTxt = `'${detailData["campaign_title"]}'참여가 승인 되었어요`;
          } else if (itemType === "admin") {
            console.log(itemType);
            userIconImg = `${appInfoContainer.imagePath}/common/icon/motiners_round_icon-228x228.png`;
            notificationLinkURL = `/task/${detailData["task_no"]}`;
            titleTxt = `🚨 '${detailData["task_title"]}' 인증사진이 규정에 맞지않아요`;
          } else {
            emptyNotification = true;
          }

          const today = new Date();
          const timeValue = new Date(value.create_date);
          const betweenTimeS = Math.floor(
            (today.getTime() - timeValue.getTime()) / 1000
          );
          const betweenTimeM = Math.floor(
            (today.getTime() - timeValue.getTime()) / 1000 / 60
          );
          const betweenTimeHour = Math.floor(betweenTimeM / 60);
          const betweenTimeDay = Math.floor(betweenTimeM / 60 / 24);

          const CommentTime = () => {
            if (betweenTimeS < 60) {
              return `${betweenTimeS}s`;
            } else if (betweenTimeM < 60) {
              return `${betweenTimeM}m`;
            } else if (betweenTimeHour < 24) {
              return `${betweenTimeHour}h`;
            } else if (betweenTimeDay < 365) {
              return `${betweenTimeDay}d`;
            } else {
              return `${Math.floor(betweenTimeDay / 365)}y`;
            }
          };
          if (!emptyNotification) {
            switch (value.type) {
              case "task_like":
              case "task_comment":
              case "campaign_post":
              case "campaign_post_like":
              case "campaign_post_comment":
              case "group_post":
              case "group_post_like":
              case "campaign_join_denied":
              case "campaign_join_approved":
              case "group_post_comment":
              case "admin":
                return (
                  <AlarmList
                    key={`notification-no-${value["no"]}`}
                    title={titleTxt}
                    time={CommentTime()}
                    detailData={detailData}
                    profileUserNo={iconUserNo}
                    userIconImg={userIconImg}
                    notificationLinkURL={notificationLinkURL}
                  />
                );
              case "friend_request":
                return (
                  <AlarmListadd
                    key={`notification-no-${value["no"]}`}
                    title={detailData.from_nickname}
                    time={value.time}
                    btntxt={value.btntxt}
                    setCurrentPostIndex={setCurrentPostIndex}
                    detailData={detailData}
                    joinSubmit={joinSubmit}
                    value={value}
                    userIconImg={userIconImg}
                  />
                );
              default:
                return null;
            }
          }
        })}
      </Setlistinner>
    </MypageSetInner>
  );
}

function AlarmList({
  title,
  time,
  profileUserNo,
  userIconImg,
  notificationLinkURL,
}) {
  const profileLink = profileUserNo
    ? `/task/friend/${profileUserNo}/list`
    : notificationLinkURL;
  return (
    <Noticelist>
      <SetlistSpan>
        <Link to={profileLink}>
          <Alarmimg>
            <UserImgTag src={userIconImg} />
          </Alarmimg>
        </Link>
        <Link to={`${notificationLinkURL}`}>
          <Alarmtxtbox>
            <Alarmtxt>{title}</Alarmtxt>
            <Alarmtime>{time}</Alarmtime>
          </Alarmtxtbox>
        </Link>
      </SetlistSpan>
    </Noticelist>
  );
}

function AlarmListadd({
  title,
  time,
  setCurrentPostIndex,
  detailData,
  joinSubmit,
  value,
  userIconImg,
}) {
  const [buttonState, setButtonState] = useState(false);

  function onClick() {
    setButtonState(true);
    joinSubmit(detailData.request_no);
  }
  function offClick() {
    setButtonState(false);
    setCurrentPostIndex(detailData.from_user_no);
  }
  return (
    <Noticelist>
      <SetlistSpan2>
        <Alarmvar2>
          <Link to={`/task/friend/${detailData.from_user_no}/list`}>
            <Alarmimg>
              <UserImgTag src={userIconImg} />
            </Alarmimg>
          </Link>
          <Alarmtxtbox>
            <Alarmtxt2>{title}</Alarmtxt2>
            <Subtext>{title}님이 친구신청을 했어요</Subtext>
            <Alarmtime>{time}</Alarmtime>
          </Alarmtxtbox>
        </Alarmvar2>
        {value.detail_json.data.is_friend_requested_received ? (
          <AddFriendButton click={onClick} />
        ) : (
          <RemoveFriendButton click={offClick} />
        )}
      </SetlistSpan2>
    </Noticelist>
  );
}

function AddFriendButton({ click }) {
  return (
    <PlusBtn onClick={click}>
      <PlusBtnimg>
        <img src={fnbtn} />
      </PlusBtnimg>
      친구
    </PlusBtn>
  );
}

function RemoveFriendButton({ click }) {
  return (
    <PlusBtn2 onClick={click}>
      친구
      <CkBtnimg>
        <img src={friend_check} />
      </CkBtnimg>
    </PlusBtn2>
  );
}
const MypageSetInner = styled.div`
  min-height: 100vh;
  height: auto;
  padding: calc(100vw * (51 / 375)) 0 calc(100vw * (60 / 375)) 0;
  overflow-y: scroll;
  height: 100vh;
  // background: #f7f7f7;
`;

const Setlistinner = styled.ul`
  // border-bottom: solid  calc(100vw*(12/375)) #f7f7f7;

  & > li:last-child {
    // border-bottom: 0;
  }
`;
const Noticelist = styled.li`
  // height : calc(100vw*(68/375));
  padding: 0 calc(100vw * (17 / 375)) 0;
  background: #fff;
`;
const SetlistSpan = styled.span`
  display: flex;
  align-items: center;
  // justify-content: space-between;
  height: 100%;
  width: 100%;
  padding: calc(100vw * (15 / 375)) 0 calc(100vw * (13 / 375)) 0;
`;

const SetlistSpan2 = styled(SetlistSpan)`
  justify-content: space-between;
`;
const Alarmimg = styled.span`
  display: block;
  border-radius: 50%;
  width: calc(100vw * (56 / 375));
  height: calc(100vw * (55 / 375));
  object-fit: contain;
  overflow: hidden;
  border: solid calc(100vw * (1 / 375)) #c6c6c6;
`;
const Alarmtxtbox = styled.span`
  display: block;
  margin-left: calc(100vw * (9 / 375));
  max-width: calc(100vw * (265 / 375));
  width: auto;
`;
const Alarmtxt = styled.em`
  display: block;
  font-size: calc(100vw * (14 / 375));
  font-weight: 500;
  line-height: 1.8;
`;
const Alarmtxt2 = styled(Alarmtxt)`
  width: calc(100vw * (162 / 375));
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
const Subtext = styled.span`
  // width: calc(100vw*(162/375));
  // overflow: hidden;
  // text-overflow: ellipsis;
  // white-space: nowrap;
  font-size: calc(100vw * (12 / 375));
  text-align: left;
  color: #707070;
`;
const Alarmtime = styled.em`
  display: block;
  font-size: calc(100vw * (10 / 375));
  color: #989898;
`;

const Alarmvar2 = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
const PlusBtn = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: calc(100vw * (12 / 375));
  font-weight: 500;
  color: #4e4e4e;
  width: calc(100vw * (67 / 375));
  height: calc(100vw * (27 / 375));
  border-radius: calc(100vw * (5 / 375));
  border: solid calc(100vw * (1 / 375)) #e6e6e6;
  background-color: #ffffff;
`;
const PlusBtn2 = styled(PlusBtn)`
  background-color: #4e4e4e;
  color: #fff;
`;
const PlusBtnimg = styled.span`
  display: block;
  width: calc(100vw * (8 / 375));
  height: calc(100vw * (8 / 375));
  margin-right: calc(100vw * (3 / 375));
`;
const CkBtnimg = styled.span`
  display: block;
  width: calc(100vw * (10.2 / 375));
  height: calc(100vw * (7.9 / 375));
  margin-left: calc(100vw * (3 / 375));
`;
const UserImgTag = styled.img`
  object-fit: cover;
  width: 100%;
  height: 100%;
`;
